import Footer from '../features/footer/footer';
import Header from '../features/headers/header';
import LandingOverview from '../features/landing/layouts/overview';
import { MAIN_CONTENT_ID } from '../global/config/layout';

export default function HomePage() {
    return (
        <>
            <Header />
            <main id={MAIN_CONTENT_ID} className="app-shell__main" tabIndex={-1}>
                <LandingOverview />
            </main>
            <Footer />
        </>
    );
}
